import ClientEdit from "../Client/ClientEdit";
import CollaboratorEdit from "../Collaborator/CollaboratorEdit";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";
import SupplierEdit from "../Supplier/SupplierEdit";
import { injectIntl } from "react-intl";

const TierUpdateSideModal = ({
  title,
  updateSideModalVisible,
  setUpdateSideModalVisible,
  sendNotification,
  companyDefaultInfos,
  onSubmit,
  tiersType,
  tiersId,
  intl
}) => {
  const Component =
    tiersType === "collaborator"
      ? CollaboratorEdit
      : tiersType === "client"
      ? ClientEdit
      : SupplierEdit;
  return (
    <SideModal
      title={
        title +
        " " +
        intl.formatMessage({ id: `ids_${tiersType}` }).toLowerCase()
      }
      width="medium-wide"
      visible={updateSideModalVisible}
      handleClose={() => setUpdateSideModalVisible(false)}>
      <Component
        inSideModal
        id={tiersId}
        // currency={companyDefaultInfos.company.currency}
        onSubmit={values => {
          console.log("TierUpdateSideModal.onSubmit", values);
          onSubmit(tiersType, values);
        }}
        companyDefaultInfos={companyDefaultInfos}
        sendNotification={sendNotification}
        // companyId={companyId}
        cancel={() => setUpdateSideModalVisible(false)}
      />
    </SideModal>
  );
};

export default injectIntl(TierUpdateSideModal);
